import { Grid } from "@mui/material";
import SoftTypography from "components/SoftTypography";
import React from "react";
import PropTypes from "prop-types";

const Firma = ({ marginTop, ultimo }) => {
  return (
    <Grid
      container
      sx={{
        pageBreakAfter: !ultimo ? "always" : "avoid",
      }}
      mt={marginTop || 6}
      mb={10}
      display="flex"
      flexDirection="row"
      justifyContent="space-around"
    >
      <Grid
        xs={4}
        sx={{
          borderTop: "1px solid black",
        }}
        display="flex"
        justifyContent="center"
      >
        <SoftTypography color="black" variant="caption">
          Responsable técnico
        </SoftTypography>
      </Grid>
      <Grid
        xs={4}
        sx={{
          borderTop: "1px solid black",
        }}
        display="flex"
        justifyContent="center"
      >
        <SoftTypography color="black" variant="caption">
          Gerente de la planta en San Luis
        </SoftTypography>
      </Grid>
    </Grid>
  );
};
Firma.propTypes = {
  marginTop: PropTypes.number,
  ultimo: PropTypes.bool,
};

export default Firma;
